//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionReadAloudFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 17L11 21H13V4H11L6 8H2V17H6Z" fill="currentColor" /><path d="M15 9.89L16.57 8.57C17.1663 9.61481 17.4799 10.797 17.4799 12C17.4799 13.203 17.1663 14.3852 16.57 15.43L15 14.11C15.3158 13.4514 15.4797 12.7304 15.4797 12C15.4797 11.2696 15.3158 10.5486 15 9.89Z" fill="currentColor" /><path d="M19.48 12C19.4808 13.6732 19.0094 15.3127 18.12 16.73L19.67 18C20.838 16.2169 21.4602 14.1316 21.4602 12C21.4602 9.86839 20.838 7.78312 19.67 6L18.12 7.3C19.004 8.70862 19.4752 10.337 19.48 12Z" fill="currentColor" /></svg>;
}
export default IconActionReadAloudFill;